import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const COLORS = {
  primary: "#F15A24", // Orange accent
  darkBlue: "#060544", // Main background
  white: "#FFFFFF",
  lightGray: "#F8F8F8"
};

const Footer = () => {
  const [data, setData] = useState({ 
    socials: [], 
    addresses: [], 
    copyText: ""
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const mockData = {
          socials: [
            { icon: "facebook", link: "https://www.facebook.com/jgalfalahmanagement/" },
            { icon: "youtube", link: "#" },
            { icon: "linkedin", link: "https://www.linkedin.com/company/jg-alfalah/" },
            { icon: "instagram", link: "https://www.instagram.com/jgalfalah1861/" }
          ],
          addresses: [
            { 
              heading: "Malaysia Office", 
              detail: "VIDA Bukit Ceylon, 10-03, 1d, Jalan Ceylon, Bukit Ceylon, 50200 Kuala Lumpur", 
              email: "admin@jgalfalah.com", 
              phoneNumber: "+601111499040" 
            },
            { 
              heading: "Saudi Arabia Office", 
              detail: "Al Rossais Commercial & Residential Complex, Ahmad Al Hawwari St, Al Murabba, Office No-604, 6th Floor, Riyadh 12626", 
              email: "marketing@jgalfalah.com", 
              phoneNumber: "+966536333427" 
            },
            { 
              heading: "Bangladesh Office", 
              detail: "House-31, Road-17, Block-E, Banani, Dhaka-1213", 
              email: "operation@stechgroupbd.com", 
              phoneNumber: "+8801321145905" 
            }
          ],
          copyText: "© Copyright 2024 by Stechhrbd. All Rights Reserved. Developed By Blockchain Technology"
        };
        setData(mockData);
      } catch (error) {
        console.error("Error loading footer data:", error);
      }
    };
    
    fetchData();
  }, []);

  return (
    <footer className="relative overflow-hidden" style={{ backgroundColor: COLORS.darkBlue }}>
      <div className="absolute inset-0 opacity-20 bg-contain bg-[url('https://img.freepik.com/free-vector/worldwide-global-map-outline-black-background_1017-46153.jpg?t=st=1743109998~exp=1743113598~hmac=17cfe1de0f1ae844496637d3bf2333ccc0c1d78034f74a3d752826165d19390a&w=2000')]"></div>
      <div className="container mx-auto px-4 py-12 relative z-10">
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="md:col-span-1">
            <div className="flex items-center mb-4">
              <Link to="/" className="flex items-center">
                <img 
                  src="https://stechhr.com.bd/wp-content/uploads/2020/12/logo-Header.png" 
                  alt="STECH HR Logo" 
                  className="h-16 object-contain"
                />
              </Link>
            </div>
            <p className="text-gray-300 text-sm mb-6">
              Stech HR is one of the most reputed human resource management companies in Bangladesh.
            </p>
            
            {/* Socials Section */}
            <div className="bg-white bg-opacity-10 p-4 rounded-lg mb-6 border-l-4 border-orange-500">
              <h4 className="text-orange-400 font-bold text-sm mb-2">SOCIALS</h4>
              <div className="flex space-x-3">
                {data.socials.map((social, index) => (
                  <a 
                    key={index}
                    href={social.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-8 h-8 rounded-full flex items-center justify-center bg-white bg-opacity-10 hover:bg-opacity-20 transition-all"
                    aria-label={social.icon}
                  >
                    <svg className="w-5 h-5 text-white" viewBox="0 0 24 24">
                      <path fill="currentColor" d={social.icon} />
                    </svg>
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="md:col-span-2">
            <h3 className="text-white font-semibold mb-6 text-center md:text-left">OUR GLOBAL OFFICES</h3>
            <div className="grid md:grid-cols-3 gap-6">
              {data.addresses.map((address, index) => (
                <motion.div
                  key={index}
                  className="bg-white bg-opacity-5 rounded-lg p-4 border border-white border-opacity-10 hover:border-opacity-30 transition-all"
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: index * 0.1 }}
                  whileHover={{ y: -5 }}
                >
                  <h4 className="text-orange-400 font-medium mb-2 text-sm">{address.heading}</h4>
                  <p className="text-gray-300 mb-3 text-xs">{address.detail}</p>
                  <div className="space-y-2">
                    <a href={`mailto:${address.email}`} className="flex items-center text-gray-300 hover:text-white transition-colors text-xs">
                      {address.email}
                    </a>
                    <a href={`tel:${address.phoneNumber.replace(/ /g, '')}`} className="flex items-center text-gray-300 hover:text-white transition-colors text-xs">
                      {address.phoneNumber}
                    </a>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
        <div className="border-t border-white border-opacity-10 pt-6">
          <p className="text-gray-400 text-xs text-center">{data.copyText}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
